var XMLNode		 = require('../xml/XMLNode');

/**
 * The XMLFile class is a subclass of XMLNode that enriches the
 * object by path and file name information.
 *
 * @param {Object} oConfig - The configuration object for this XMLFile
 * @param {string} oConfig.path - The relative path of this XMLFile
 * @param {string} oConfig.filename - The file name of this XMLFile
 * @class
 */
function XMLFile(oConfig) {
	XMLNode.call(this, oConfig);

	this._filename = oConfig.filename;
	this._path = oConfig.path;
}

XMLFile.prototype = Object.create(XMLNode.prototype);
XMLFile.prototype.constructor = XMLFile;

/**
 * Returns the name of this particular file including its file extension.
 *
 * @returns {string} Name of the file
 */
XMLFile.prototype.getFileName = function() {
	return this._filename;
};

/**
 * Assigns the given string as name of the file. The name must contain a file extension.
 *
 * @param {string} sFileName - Name of the file
 */
XMLFile.prototype.setFileName = function(sFileName) {

	if (!sFileName.match(/^\S+\.\S{3,4}$/)) {
		throw new Error('Invalid file name: ' + sFileName);
	}

	this._filename = sFileName;
};

/**
 * Returns the path of the file without any filename.
 *
 * @returns {string} - Path of the file
 */
XMLFile.prototype.getPath = function() {
	return this._path;
};

/**
 * Returns the absolute Path to the file.
 *
 * @returns {string} - Absolute path including the filename
 */
XMLFile.prototype.getAbsolutePath = function() {
	return this.getPath() + this.getFileName();
};

/**
 * Assigns the given path to this XMLFile. The path needs to end with
 * a slash to match the criteria.
 *
 * @param {string} sPath - Relative path of this XMLFile
 */
XMLFile.prototype.setPath = function(sPath) {

	/* IE compatible endsWith */
	if (!sPath || sPath.lastIndexOf('/') !== (sPath.length - 1)) {
		throw new Error('Invalid file path: ' + sPath);
	}

	this._path = sPath;
};

/**
 * Performs a serialization of this XMLFile based on the XMLNode#serialize
 * implementation. The optional parameter allows to finalize this XMLFile
 * so that all aggregations will be cleared and the cleanup hook
 * XMLFile#cleanup will be executed. The aggregations will be cleared
 * outside of the cleanup function. This will ensure proper cleanup
 * even is the subclass is not calling the super class function.
 *
 * @param {boolean} [bFinalize]
 * Forces the XMLFile to destroy its aggregations. It will call the
 * cleanup function of the instance. This can be used as a hook for
 * subclasses that inherit from XMLFile. This frees additional memory
 * but should used with caution because after serialization all
 * content will be lost.
 *
 * @returns {string} The serialized XMLFile
 *
 * @Overrides XMLNode#serialize
 */
XMLFile.prototype.serialize = function(bFinalize) {
	var sSerializedString;

	sSerializedString = Object.getPrototypeOf(XMLFile.prototype).serialize.call(this);

	if (bFinalize) {
		this.childs.length = 0;

		this.cleanup();
	}

	return sSerializedString;
};

/**
 * Abstract function that can be overridden as a cleanup hook.
 * @abstract
 */
XMLFile.prototype.cleanup = function() {

	/* Do nothing */
};

module.exports = XMLFile;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/xml/XMLFile.js
// module id = 1
// module chunks = 0